import { call, put, select, takeLatest } from 'redux-saga/effects'
import { TimesConstants } from '../store/times.constants'
import { ITimesState } from '../store/times.types'
import { getTimesSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setSaveTimesResponse } from '../store/times.actions'
import { addTimesItem } from '../../timeline/store/timeline.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveTimes() {
  const times: ITimesState = yield select(getTimesSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc, times }
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSaveTimesResponse(response))
      yield put(addTimesItem())
    } catch (e) {
      yield put(throwPcrException(`saveTimes() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveTimesSaga() {
  yield takeLatest(
    [
      TimesConstants.SET_ONSET_TIME,
      TimesConstants.SET_ONSET_DATE,
      TimesConstants.SET_RECEIVED_TIME,
      TimesConstants.SET_RECEIVED_DATE,
      TimesConstants.SET_DISPATCH_NOTIFIED_TIME,
      TimesConstants.SET_DISPATCH_NOTIFIED_DATE,
      TimesConstants.SET_STANDBY_TIME,
      TimesConstants.SET_STANDBY_DATE,
      TimesConstants.SET_DISPATCHED_TIME,
      TimesConstants.SET_DISPATCHED_DATE,
      TimesConstants.SET_ACKNOWLEDGED_TIME,
      TimesConstants.SET_ACKNOWLEDGED_DATE,
      TimesConstants.SET_EN_ROUTE_TIME,
      TimesConstants.SET_EN_ROUTE_DATE,
      TimesConstants.SET_STAGING_TIME,
      TimesConstants.SET_STAGING_DATE,
      TimesConstants.SET_ON_SCENE_TIME,
      TimesConstants.SET_ON_SCENE_DATE,
      TimesConstants.SET_AT_PATIENT_TIME,
      TimesConstants.SET_AT_PATIENT_DATE,
      TimesConstants.SET_TRANSFER_CARE_EMS_TIME,
      TimesConstants.SET_TRANSFER_CARE_EMS_DATE,
      TimesConstants.SET_LEAVE_REFERRING_TIME,
      TimesConstants.SET_LEAVE_REFERRING_DATE,
      TimesConstants.SET_ARRIVE_RECEIVING_TIME,
      TimesConstants.SET_ARRIVE_RECEIVING_DATE,
      TimesConstants.SET_TRANSFER_CARE_DESTINATION_TIME,
      TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE,
      TimesConstants.SET_AVAILABLE_TIME,
      TimesConstants.SET_AVAILABLE_DATE,
      TimesConstants.SET_CALL_COMPLETED_TIME,
      TimesConstants.SET_CALL_COMPLETED_DATE,
      TimesConstants.SET_IN_QUARTERS_TIME,
      TimesConstants.SET_IN_QUARTERS_DATE,
      TimesConstants.SET_CANCELLED_TIME,
      TimesConstants.SET_CANCELLED_DATE,
      TimesConstants.SET_FIRST_RESPONDER_TIME,
      TimesConstants.SET_FIRST_RESPONDER_DATE,
      TimesConstants.ADD_ONSET_CURRENT_DATETIME,
      TimesConstants.ADD_RECEIVED_CURRENT_DATETIME,
      TimesConstants.ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME,
      TimesConstants.ADD_STANDBY_CURRENT_DATETIME,
      TimesConstants.ADD_DISPATCHED_CURRENT_DATETIME,
      TimesConstants.ADD_ACKNOWLEDGED_CURRENT_DATETIME,
      TimesConstants.ADD_EN_ROUTE_CURRENT_DATETIME,
      TimesConstants.ADD_STAGING_CURRENT_DATETIME,
      TimesConstants.ADD_ON_SCENE_CURRENT_DATETIME,
      TimesConstants.ADD_AT_PATIENT_CURRENT_DATETIME,
      TimesConstants.ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME,
      TimesConstants.ADD_LEAVE_REFERRING_CURRENT_DATETIME,
      TimesConstants.ADD_ARRIVE_RECEIVING_CURRENT_DATETIME,
      TimesConstants.ADD_TRANSFER_CARE_DESTINATION_CURRENT_DATETIME,
      TimesConstants.ADD_AVAILABLE_CURRENT_DATETIME,
      TimesConstants.ADD_CALL_COMPLETED_CURRENT_DATETIME,
      TimesConstants.ADD_IN_QUARTERS_CURRENT_DATETIME,
      TimesConstants.ADD_CANCELLED_CURRENT_DATETIME,
      TimesConstants.ADD_FIRST_RESPONDER_DATETIME,
      TimesConstants.ADD_LEAVE_PATIENT_CURRENT_DATETIME,
      TimesConstants.SET_LEAVE_PATIENT_TIME,
      TimesConstants.SET_LEAVE_PATIENT_DATE,
      TimesConstants.SET_DESCENT_TIME,
      TimesConstants.SET_DESCENT_DATE,
      TimesConstants.ADD_DESCENT_CURRENT_DATETIME,
      TimesConstants.SET_AT_LANDING_TIME,
      TimesConstants.SET_AT_LANDING_DATE,
      TimesConstants.ADD_AT_LANDING_CURRENT_DATETIME,
      TimesConstants.SET_ONSET_DATE_TIME_PNNV,
      TimesConstants.SET_RECEIVED_DATE_TIME_PNNV,
      TimesConstants.SET_EN_ROUTE_DATE_TIME_PNNV,
      TimesConstants.SET_ON_SCENE_DATE_TIME_PNNV,
      TimesConstants.SET_AT_PATIENT_DATE_TIME_PNNV,
      TimesConstants.SET_TRANSFER_CARE_EMS_DATE_TIME_PNNV,
      TimesConstants.SET_LEAVE_REFERRING_DATE_TIME_PNNV,
      TimesConstants.SET_ARRIVE_RECEIVING_DATE_TIME_PNNV,
      TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE_TIME_PNNV,
      TimesConstants.SET_CUSTOM_1_DATE,
      TimesConstants.SET_CUSTOM_1_TIME,
      TimesConstants.SET_CUSTOM_1_DATETIME,
      TimesConstants.SET_CUSTOM_2_DATE,
      TimesConstants.SET_CUSTOM_2_TIME,
      TimesConstants.SET_CUSTOM_2_DATETIME,
      TimesConstants.SET_CUSTOM_3_DATE,
      TimesConstants.SET_CUSTOM_3_TIME,
      TimesConstants.SET_CUSTOM_3_DATETIME,
      TimesConstants.SET_CUSTOM_4_DATE,
      TimesConstants.SET_CUSTOM_4_TIME,
      TimesConstants.SET_CUSTOM_4_DATETIME,
    ],
    performWithMutexHOG,
    saveTimes
  )
}
